import netDialAPI from './netDialAPI';
import cstaDefs from './cstaDefs';

export { netDialAPI, cstaDefs };

export default netDialAPI;



// WEBPACK FOOTER //
// ./src/util/call/neomecca/netDialAPI/index.js